import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import AssetGeneralCategoryType from './assetGeneralCategoryType';
import SinglePicker from '../common/controls/singlePicker';
import TextInput from '../common/controls/textInput';
class AssetGeneral extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeStatusID = this.handleChangeStatusID.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      assetStatus = _this$props.assetStatus,
      assetStatusActions = _this$props.assetStatusActions;
    assetStatusActions.serverIndex(assetStatus.indexQuery);
  }
  handleChange(fieldName, value) {
    const _this$props2 = this.props,
      assetID = _this$props2.asset.id,
      assetActions = _this$props2.assetActions;
    assetActions.change(assetID, fieldName, value);
  }
  handleChangeStatusID(value) {
    const _this$props3 = this.props,
      assetID = _this$props3.asset.id,
      assetActions = _this$props3.assetActions;
    assetActions.change(assetID, 'assetStatusID', value);
  }
  render() {
    const _this$props4 = this.props,
      asset = _this$props4.asset,
      assetStatus = _this$props4.assetStatus;
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", {
      className: "t-ag-section-title"
    }, "General"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "Asset ID",
      field: "name",
      data: asset,
      onChange: this.handleChange,
      entity: "Asset"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Status",
      labelKey: "name",
      onChange: this.handleChangeStatusID,
      options: assetStatus.list,
      placeholder: "Select...",
      value: asset.assetStatusID,
      returnValueKey: "id",
      searchable: false
    }))), /*#__PURE__*/React.createElement(AssetGeneralCategoryType, {
      asset: asset,
      assetChange: this.handleChange
    }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "Alias",
      field: "alias",
      data: asset,
      onChange: this.handleChange,
      entity: "Asset"
    }))));
  }
}
AssetGeneral.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    assetStatusID: PropTypes.string
  }).isRequired,
  assetActions: PropTypes.shape({
    change: PropTypes.func
  }).isRequired,
  assetStatus: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetStatusActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
export { AssetGeneral as TestAssetGeneral };
export default entityComposition(AssetGeneral, ['assetStatus']);